import Store from "@/store/index.js"
const updateMenuService = function (keyClock) {
  // let keyClock = router.app.$keycloak
  let leftNav = Store.getters.currentMenus
  let currentLanguage = Store.state.currentLanguage
  let children = keyClock.hasRealmRole("admin")
    ? Store.state.currentModel === "manager"
      ? [
          {
            label: "用户模式",
            path: "/portalApplication"
          },
          {
            label: "退出登录",
            path: "/menuServeLogout"
          }
        ]
      : [
          {
            label: "管理员模式",
            path: "/userManage"
          },
          {
            label: currentLanguage === 'en' ? 'Logout' : "退出登录",
            path: "/menuServeLogout"
          }
        ]
    : [
        {
          label: currentLanguage === 'en' ? 'Logout' : "退出登录",
          path: "/menuServeLogout"
        }
      ]

  let userInfo = {
    label: keyClock.userName,
    children: children
  }
  let timer = setInterval(() => {
    if (window.menuService) {
      if(Store.state.currentModel === 'user' && currentLanguage == 'en') {
        if (location.origin.indexOf('qikan') > -1 || location.origin.indexOf('journal') > -1) {
          leftNav[0].label = 'My Account'
        } else {
          leftNav[0].label = 'My Applications'
          leftNav[1].label = 'My Account'
        }
      }
      // let items = document.querySelectorAll('.TopMenuItem')
      // if (items.length > 1) {
      //   let item = items[0].querySelector('.el-dropdown-link span')
      //   if (Store.state.currentLanguage == 'en') {
      //     item.innerHTML = 'English'
      //     Store.state.currentModel === 'user' ? userInfo.children[userInfo.children.length - 1].label = 'Logout' : ''
      //   } else {
      //     item.innerHTML = '中文（简体）'
      //     Store.state.currentModel === 'user' ? userInfo.children[userInfo.children.length - 1].label = '退出登录' : ''
      //   }
      //   Store.state.currentModel === "manager" ? items[0].style.display= "none" : items[0].style.display= "block"
      // }
      window.menuService.update({
        leftNav,
        userInfo
      })
      clearInterval(timer)
    }
  }, 50)
}
export default updateMenuService;